import { render, staticRenderFns } from "./ProductElabel.vue?vue&type=template&id=7aa09425&scoped=true"
import script from "./ProductElabel.vue?vue&type=script&lang=js"
export * from "./ProductElabel.vue?vue&type=script&lang=js"
import style0 from "./ProductElabel.vue?vue&type=style&index=0&id=7aa09425&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa09425",
  null
  
)

export default component.exports